// src/components/SmartFlow/nodes/ActionNode.jsx

import React from 'react';
import BaseNode from './base/BaseNode';

/**
 * Action Node Component
 * Handles different types of actions (CRM, Automation, API, etc.)
 */
const ActionNode = ({ data, type, selected }) => {
  const config = data.config || {};

  // Determine icon, color, and label based on action type
  const getNodeProps = () => {
    switch (type) {
      case 'ACTION_CRM':
        return {
          icon: 'bi-person-circle',
          color: '#2ecc71',
          label: 'CRM Action',
          subtitle: config.action_type || 'CRM operation',
        };
      case 'ACTION_AUTOMATION':
        return {
          icon: 'bi-robot',
          color: '#9b59b6',
          label: 'Automation',
          subtitle: config.action_type || 'Automated task',
        };
      case 'ACTION_API':
        return {
          icon: 'bi-cloud-arrow-up',
          color: '#e67e22',
          label: 'API Call',
          subtitle: config.url || 'API request',
        };
      default:
        return {
          icon: 'bi-gear',
          color: '#27ae60',
          label: data.label || 'Action',
          subtitle: config.action_type || 'Configure action',
        };
    }
  };

  const nodeProps = getNodeProps();

  return (
    <BaseNode
      data={data}
      icon={nodeProps.icon}
      color={nodeProps.color}
      label={nodeProps.label}
      subtitle={nodeProps.subtitle}
      hasHandles={{ top: true, bottom: true }}
      selected={selected}
    />
  );
};

export default ActionNode;
